module.exports = __webpack_public_path__ + "img/626b9df082eed.0e2c402b.jpg";